/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboxArchiveAllRequest
 */
export interface InboxArchiveAllRequest {
    /**
     * IDs of the notifications the inbox is showing. They are archived even if SuprSend already records them as archived. IDs that are not the signed-in user's are ignored.
     */
    message_ids?: Array<string>;
}

/**
 * Check if a given object implements the InboxArchiveAllRequest interface.
 */
export function instanceOfInboxArchiveAllRequest(value: object): value is InboxArchiveAllRequest {
    return true;
}

export function InboxArchiveAllRequestFromJSON(json: any): InboxArchiveAllRequest {
    return InboxArchiveAllRequestFromJSONTyped(json, false);
}

export function InboxArchiveAllRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboxArchiveAllRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message_ids': json['message_ids'] == null ? undefined : json['message_ids'],
    };
}

export function InboxArchiveAllRequestToJSON(json: any): InboxArchiveAllRequest {
    return InboxArchiveAllRequestToJSONTyped(json, false);
}

export function InboxArchiveAllRequestToJSONTyped(value?: InboxArchiveAllRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_ids': value['message_ids'],
    };
}

